import {
  fieldApps,
  fieldTypes,
  typesConf,
  HEADING,
  BODY,
  getAppConfigurator,
} from '@infotech/view-config'
import { nest } from 'recompose'
import get from 'lodash/get'
import map from 'lodash/map'
import pickBy from 'lodash/pickBy'
import keyBy from 'lodash/keyBy'
import {
  Text,
  Input,
  WithTitle,
  InputHelper,
  formFieldAdapter,
} from '@infotech/base-components'
import { textSearchFilters } from '@infotech/filters'
import UIKitInput from '@infotech/uikit-input'
import { createGetColumnsConf } from '@infotech/crud'
import NameFormatter from './components/COLUMN/NameFormatter'

const AdaptedInput = formFieldAdapter(UIKitInput)

export const fieldsConf = {
  id: {
    type: fieldTypes.TEXT,
    name: `id`,
    apps: {
      [fieldApps.COLUMN]: {
        name : `id`,
        width: 70,
      },
      [fieldApps.VIEW]: {
        place    : HEADING,
        component: nest(WithTitle, Text),
        title    : `id`,
      },
      [fieldApps.FILTER]: {
        title    : `id`,
        component: Input,
      },
    },
  },
  name: {
    type: fieldTypes.TEXT,
    name: `Название`,
    apps: {
      [fieldApps.COLUMN]: {
        name          : `Название`,
        sortable      : true,
        formatter     : NameFormatter,
        getRowMetaData: (row) => row,
      },
      [fieldApps.VIEW]: {
        place    : BODY,
        component: nest(WithTitle, Text),
        title    : `Название`,
      },
      [fieldApps.FILTER]: {
        title        : `Название`,
        component    : AdaptedInput,
        parseValue   : textSearchFilters.parseValue,
        valueToFilter: textSearchFilters.valueToFilter,
      },
      [fieldApps.FORM]: {
        place    : BODY,
        title    : `Название`,
        component: nest(InputHelper, AdaptedInput),
        type     : `textarea`,
      },
    },
  },
}

export const defaultColumnsList = [
  `id`,
  `name`,
]

export const defaultFormList = [
  `name`,
]

export const defaultFormListEdit = [
  `name`,
]

export const defaultViewList = [
  `id`,
  `name`,
]

export const defaultFilterList = [
  `id`,
  `name`,
]

export const allColumnsList = map(
  pickBy(fieldsConf, (field) => get(field, [`apps`, fieldApps.COLUMN])),
  ({ name }, key) => ({
    key,
    name,
  }),
)

export const issuesAppsConf = (fieldsConfig) => getAppConfigurator(fieldsConfig, typesConf)

export const getColumnsConf = (
  fieldsList = defaultColumnsList, fieldsConfig = fieldsConf
) => createGetColumnsConf(issuesAppsConf(fieldsConfig)(fieldApps.COLUMN), fieldsList)

export const getViewConfig = (
  fieldsList = defaultViewList, fieldsConfig = fieldsConf
) => fieldsList.map(issuesAppsConf(fieldsConfig)(fieldApps.VIEW))

export const getFilterConfig = (
  fieldsList = defaultFilterList, fieldsConfig = fieldsConf
) => keyBy(fieldsList.map(issuesAppsConf(fieldsConfig)(fieldApps.FILTER)), `key`)

export const getFormConfig = (
  fieldsList = defaultFormList, fieldsConfig = fieldsConf
) => keyBy(fieldsList.map(issuesAppsConf(fieldsConfig)(fieldApps.FORM)), `key`)

export const configWithData = (issue, config) => config.map((field) => ({
  ...field,
  data: issue[field.key],
}))
